import { Component, OnInit, ViewEncapsulation, input, inject } from '@angular/core';

import { ApWindowService } from '@ap/cdk';
import { ApIconLinkComponent } from '@ap/icon-link';
import { ApIconComponent } from '@ap/icon';

@Component({
    selector: 'ap-phone-link',
    templateUrl: './phone-link.component.html',
    styleUrls: ['./phone-link.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIconLinkComponent, ApIconComponent]
})
export class ApPhoneLinkComponent implements OnInit {
    private readonly windowService = inject(ApWindowService);

    /**
     * Required - Phone number to call when link is clicked
     */
    public readonly phoneNumber = input.required<string>();

    /**
     * Required - Text to show in link
     */
    public readonly text = input.required<string>();

    /**
     * Icon to show. Options are: `phone` or `advisor`.
     * Defaults to `phone`.
     */
    public readonly icon = input<'phone' | 'advisor'>('phone');

    public isMobile: boolean;

    public ngOnInit() {
        this.isMobile = this.windowService.supportsNativeApp();
    }
}
